import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class CartaDePorteDescargada {
  static getConsultaCeaTicketDescarga (cartaDePorteAutomotor) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_cea_ticket_descarga?r=` +
        `{"clave":{"carta_de_porte_automotor":"${cartaDePorteAutomotor}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
      .catch(lrsAdapter)
  }

  static getDatosExtrasDescarga (exportador, cereal) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/datos_extras_descarga?r=` +
        `{"clave":{"exportador":"${exportador}", "cereal":"${cereal}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
      .catch(lrsAdapter)
  }

  static getInterdictoDeCartaDePorteAutomotor (cartaDePorteAutomotor) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/interdicto_de_carta_de_porte_automotor?r=` +
        `{"clave":{"carta_de_porte_automotor":"${cartaDePorteAutomotor}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
      .catch(lrsAdapter)
  }
}

export default CartaDePorteDescargada
